<template>
  <div class="home">
    <swiper></swiper>
    <ul>
      <template v-for="(item,index) in menu">
        <router-link
          tag="li"
          :to="{path:item.router}"
          :key="index"
          v-if="item.ishow"
          :data-router="item.router"
          class="flex-box flex-d-c flex-h-c"
        >
          <img class="icon" :src="item.icon" alt v-if="item.icon" v-cloak />
          <div v-cloak>{{item.name}}</div>
          <div
            v-if="item.router=='/memberApply' && memberApplyRedDotCount>0"
            class="memberApplyRedDotCount flex-box flex-hv-c"
          >{{memberApplyRedDotCount}}</div>
        </router-link>
      </template>
    </ul>
    <div class="flex-box flex-hv-c compnay" v-show="partnerCompnay">{{partnerCompnay}}</div>
    <!-- 钻石商城弹窗 -->
    <transition name="fade">
      <div
        v-if="!isLogin && diamondWranShow && diamondMallActive && diamondMallActive.endTime > serverTime"
      >
        <diamondWran @closeView="closeView"></diamondWran>
      </div>
    </transition>
  </div>
</template>

<script>
import router from '../../router'
import swiper from './swiper.vue'
import diamondWran from './alert/diamondMall.vue'
import { Toast } from 'mint-ui'
export default {
  name: 'home',
  components: { swiper, diamondWran },
  data() {
    return {
      env: localStorage.getItem('env'),
      menu: [
        { icon: 'http://image.shrongyikeji.com/manager/baobiao.png', name: '报表数据', router: '/reportData', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/daili.png', name: '我的代理', router: '/member', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/shouquan.png', name: '授权代理', router: '/addMember', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/geren.png', name: '商务查询', router: '/managerFind', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/award.png', name: '代理奖励', router: '/memberAward', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/yujing.png', name: '代理预警', router: '/memberWarn', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/clubSearch.png', name: '亲友圈', router: '/club', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/report.png', name: '商务报备', router: '/managerReport', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/qiehuan.png', name: '切换申请', router: '/toggle', ishow: true },
        { icon: 'http://image.shrongyikeji.com/manager/delClub.png', name: '删亲友圈', router: '/delClub', ishow: true },
        { icon: './static/img/awardProgress.png', name: '奖励进度', router: '/awardProgress', ishow: true },
        { icon: './static/img/memberApply.png', name: '申请代理', router: '/memberApply', ishow: true },
        { icon: './static/img/zengsong.png', name: '赠送申请', router: '/giftApplication', ishow: true },
        { icon: './static/img/zengsong.png', name: '商户管理', router: '/merchantManagement', ishow: false },
        { icon: 'http://image.shrongyikeji.com/member/zhanghu.png', name: '我的账户', router: '/myAccount', ishow: true }
      ],
      //每次登陆
      // isLogin: sessionStorage.getItem('isLogin'),
      diamondWranShow: false,
      isFirstLogin: false,
      // gemStatus : this.$store.state.userMsg.userMsg.gemStatus
    }
  },
  methods: {
    closeView() {
      sessionStorage.setItem('isLogin', 1)
      this.diamondWranShow = false;
    },
    /**刷新用户信息**/
    resUserInfo() {
      var that = this
      that.$store.dispatch('getUserMsg')//初始请求用户信息 得到数据 存放store中
    },
    /****
    *判断是否是否首次登陆
    * ***/
    checkFirstLogin() {
      var that = this
      var now = new Date();
      now.setHours(0, 0, 0, 0);
      if (localStorage.lastLoginTime) {
        if (localStorage.lastLoginTime < now.getTime() || localStorage.lastLoginTime == "null") {
          that.isFirstLogin = true
          localStorage.setItem('lastLoginTime', '')//防止刷新
        }
      }
    },
  },
  watch: {
    partnerState(v, ov) {
      //新商务 没有商务查询
      for (let i = 0; i < this.menu.length; i++) {
        if (this.menu[i].name == '商务查询') {
          if (v == 2) {
            this.menu[i].ishow = false
          }
          else {
            this.menu[i].ishow = true
          }
        }
      }
    },
    gemStatus(newVal , oldVal){ console.log(newVal)
      this.menu.forEach((item , index) => {
        if(item.router == '/merchantManagement'){
          if(newVal == 3 || newVal == 0){ // 封禁
            item.ishow = false;
          } else {
            item.ishow = true;
          }
        } 
      })
    }
  },
  computed: {
    serverTime() {
      return this.$store.state.userMsg.userMsg.serverTime
    },
    diamondMallActive() {
      return this.$store.state.userMsg.userMsg.fangkaStoreActivity
    },
    isLogin() {
      return sessionStorage.getItem('isLogin')
    },
    partnerState() {
      return this.$store.state.userMsg.userMsg.partnerState
    },
    partnerCompnay() {
      return this.$store.state.userMsg.partnerCompnay
    },
    memberApplyRedDotCount() {
      return this.$store.state.userMsg.userMsg.memberApplyRedDotCount
    },
    gemStatus(){
      return this.$store.state.userMsg.userMsg.gemStatus
    }
  },
  mounted() { console.log(this.menu)
    setTimeout(function () {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 250)
  },
  created() {  console.log(this.env , ['yueyang','shaoyang'].includes(this.env))
    // this.resUserInfo()//仅用于重新获取取申请代理的小红点提示数字
    for (let i = 0; i < this.menu.length; i++) { console.log(this.env , ['yueyang','shaoyang'].includes(this.env))
      if (this.menu[i].name == '商务查询') {
        if (this.partnerState == 2) {//新商务 没有商务查询
          this.menu[i].ishow = false
        }
        else {
          this.menu[i].ishow = true
        }
      }
      if(this.menu[i].router == '/merchantManagement'){ 
          if(this.gemStatus == 3 || this.gemStatus == 0){
            this.menu[i].ishow = false;
          } else {
            this.menu[i].ishow = true;
          }
      } 
      // if(this.menu[i].router == '/myAccount'){ 
      //   if(['yueyang','shaoyang'].includes(this.env)){
      //     this.menu[i].ishow = true;
      //   }
      // } 
    }
    this.checkFirstLogin();
    if (this.env == "yueyang" || this.env == "shaoyang" || this.env == "hubei") {
      this.diamondWranShow = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
.home {
  height: 100%;
  width: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  ul {
    display: flex;
    flex-grow: 5;
    flex-wrap: wrap;
    background: #fff;
    li {
      width: calc(100% / 5);
      height: 1.8rem;
      border-right: 1px solid rgb(247, 248, 250);
      border-bottom: 1px solid rgb(247, 248, 250);
      text-align: center;
      color: #3d435f;
      .icon {
        width: 0.7rem;
        height: 0.7rem;
        margin: 0 auto 4px auto;
        border-radius: 50%;
      }
    }
    li:nth-child(5),
    li:nth-child(10) {
      border-right: 0;
    }
    [data-router="/memberApply"] {
      position: relative;
    }
    [data-router="/memberApply"] .icon {
      width: 0.8rem;
      height: 0.8rem;
      margin: 0 auto;
    }
    .memberApplyRedDotCount {
      position: absolute;
      top: 6px;
      right: 6px;
      width: 20px;
      height: 20px;
      background: orangered;
      color: #fff;
      border-radius: 50%;
      font-size: 10px;
    }
  }
  .compnay {
    height: calc(100vh - 10.4rem);
    color: #999;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/index.vue